<div class="container">
  <div class="row justify-content-center">
      <app-visual-item-info [visualItemInfo]="registrationButtonInfo"></app-visual-item-info>

      <!-- <app-booking-area-item-pack class="col-12 col-md-4 pb-4" [areaItemPack]="registrationButton" (areaItemSelected)="onAreaItemPackSelected(registrationButton, $event)"></app-booking-area-item-pack> -->
    <ng-container *ngFor="let areaItemPack of buttons">
      <app-booking-area-item-pack class="col-12 col-md-4 pb-4" [areaItemPack]="areaItemPack" (areaItemSelected)="onAreaItemPackSelected(areaItemPack, $event)"></app-booking-area-item-pack>
    </ng-container>
  </div>
</div>
